import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { WhatsAppIcon, MapPin, Clock } from './Icons';
export function CTASection() {
  return <section id="contacto" className="py-24 bg-warm-white relative" data-id="element-38">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <FadeIn data-id="element-40">
          <div className="bg-linen p-8 md:p-16 rounded-sm border border-sand text-center relative overflow-hidden" data-id="element-41">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold/30 m-4" data-id="element-42"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-gold/30 m-4" data-id="element-43"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-gold/30 m-4" data-id="element-44"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold/30 m-4" data-id="element-45"></div>

            <p className="text-terracotta font-medium tracking-widest uppercase text-sm mb-6" data-id="element-46">
              Un último pensamiento
            </p>

            <div className="max-w-2xl mx-auto mb-12 text-brown-medium text-lg space-y-4" data-id="element-47">
              <p data-id="element-48">Usted va a organizar ese evento de todas formas.</p>
              <p data-id="element-49">
                La pregunta es si la comida va a ser el detalle que lo eleve — o
                el detalle que nadie menciona porque es mejor no hacerlo.
              </p>
              <p className="font-serif italic text-xl text-deep-brown" data-id="element-50">
                Los eventos que la gente recuerda tienen algo en común: la
                anfitriona o el anfitrión cuidó todo. Incluyendo la mesa.
              </p>
            </div>

            <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-4" data-id="element-51">
              Es el momento de hablar con nosotros
            </h2>
            <p className="text-brown-medium mb-10" data-id="element-52">
              Contáctenos hoy y cuéntenos sobre su evento. Le respondemos con
              opciones concretas, sin compromiso y sin perder su tiempo.
            </p>

            <a href="https://wa.me/59892014876" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-sm text-lg font-medium transition-all duration-300 shadow-sm hover:shadow-md mb-12" data-id="element-53">
              <WhatsAppIcon className="w-6 h-6 text-white" data-id="element-54" />
              092 014 876
            </a>

            <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto text-left border-t border-sand/50 pt-10" data-id="element-55">
              <div className="flex items-start gap-4" data-id="element-56">
                <MapPin className="text-terracotta shrink-0 mt-1" data-id="element-57" />
                <div data-id="element-58">
                  <h4 className="font-medium text-deep-brown" data-id="element-59">Ubicación</h4>
                  <p className="text-brown-medium" data-id="element-60">
                    Carrasco
                    <br data-id="element-61" />
                    Montevideo, Uruguay
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-62">
                <Clock className="text-terracotta shrink-0 mt-1" data-id="element-63" />
                <div data-id="element-64">
                  <h4 className="font-medium text-deep-brown" data-id="element-65">
                    Horarios de atención
                  </h4>
                  <p className="text-brown-medium" data-id="element-66">
                    Lunes a Viernes: 9:00 – 18:00
                    <br data-id="element-67" />
                    Sábados: 9:00 – 14:00
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}